'use strict';
/**
 * Config-Clone — pure (no Pict / no rest) helpers for cloning configuration across contexts.
 *
 * A clone reads a namespace's effective config at a SOURCE scope/context (one merged object per
 * NamespaceValue) and writes the selected values at a TARGET scope/context. The Configuration service
 * diffs each Put against the target's parent, so cloning Customer-A -> Customer-B stores only what
 * differs from B's Global default. These helpers build + summarize the plan; the provider performs the
 * reads/writes.
 */

/**
 * Build a clone plan: one Put per selected NamespaceValue, carrying the source's effective config.
 * Selected values with no source config are skipped.
 * @param {Object<string, object>} pSourceConfigByValue map NamespaceValue -> merged config (from a Get-all-values at the source scope)
 * @param {Array<string>} pSelectedValues the NamespaceValues to clone
 * @return {Array<{ NamespaceValue: string, Config: object }>}
 */
function planClone(pSourceConfigByValue, pSelectedValues)
{
	const tmpSource = pSourceConfigByValue || {};
	return (pSelectedValues || [])
		.filter((pValue) => Object.prototype.hasOwnProperty.call(tmpSource, pValue))
		.map((pValue) => ({ NamespaceValue: pValue, Config: tmpSource[pValue] }));
}

/**
 * Summarize a plan for the confirm dialog / preview.
 * @param {Array<{ NamespaceValue: string }>} pPlan
 * @return {{ Count: number, Values: Array<string> }}
 */
function summarizeClonePlan(pPlan)
{
	const tmpPlan = pPlan || [];
	return { Count: tmpPlan.length, Values: tmpPlan.map((pEntry) => pEntry.NamespaceValue) };
}

module.exports = { planClone, summarizeClonePlan };
